import { render, staticRenderFns } from "./ProductListAsset.vue?vue&type=template&id=056182f8"
import script from "./ProductListAsset.vue?vue&type=script&lang=js"
export * from "./ProductListAsset.vue?vue&type=script&lang=js"
import style0 from "./ProductListAsset.vue?vue&type=style&index=0&id=056182f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports